import { type FetchPaymentTopupLobbyParams, paymentApi } from '@capsicum/common';
import { useTimerExpiredDateAtom } from '@capsicum/features/payments/shared';
import { useQuery } from '@tanstack/react-query';

export const useTopUpRatesAndLimitsQueryKey = (params: FetchPaymentTopupLobbyParams) => [
	'topupRatesAndLimits',
	params.fiatCurrencyId
];

export const useTopUpRatesAndLimitsQuery = (params: FetchPaymentTopupLobbyParams) => {
	const { configExpirationPeriod } = useTimerExpiredDateAtom();

	const topupQuery = useQuery({
		enabled: !!params.fiatCurrencyId,
		queryFn: async () => (await paymentApi).fetchPaymentTopupLobby(params),
		queryKey: useTopUpRatesAndLimitsQueryKey(params),
		select: data => ({
			...data.data,
			supportedPurchaseRange: data.data.supportedPurchaseRange?.[0]
		}),
		staleTime: configExpirationPeriod
	});

	return topupQuery;
};
